import React, { useState } from 'react';
import ImageUploader from './ImageUploader';
import ServicesImageUploader from './ServicesImageUploader';
import BlogCreator from './BlogCreator';
import BlogEditor from './BlogEditor';
import BlogDeleter from './BlogDeleter';
import Transletar from './Translater';

const ProductTab = () => {
  const [selectedTab, setSelectedTab] = useState('team');

  return (
    <div className="tab_container">
      <div className="tab_item">
        <div className="tabs_line">
          <button className={`tab_btn ${selectedTab === 'team' ? 'active' : ''}`} onClick={() => setSelectedTab('team')}>Завантажити фото</button>
          <button className={`tab_btn ${selectedTab === 'services' ? 'active' : ''}`} onClick={() => setSelectedTab('services')}>Завантажити картинку SERVICES</button>
          <button className={`tab_btn ${selectedTab === 'create' ? 'active' : ''}`} onClick={() => setSelectedTab('create')}>Створити сторінку блогу</button>
          <button className={`tab_btn ${selectedTab === 'edit' ? 'active' : ''}`} onClick={() => setSelectedTab('edit')}>Редагувати сторінку блогу</button>
          <button className={`tab_btn ${selectedTab === 'delete' ? 'active' : ''}`} onClick={() => setSelectedTab('delete')}>Видалити сторінку блогу</button>
          <button className={`tab_btn ${selectedTab === 'translater' ? 'active' : ''}`} onClick={() => setSelectedTab('translater')}>Переклад</button>
        </div>
        
        <div className="content_slider-create">
          {selectedTab === 'team' && <ImageUploader />}
          {selectedTab === 'services' && <ServicesImageUploader />}
          {selectedTab === 'create' && <BlogCreator />}
          {selectedTab === 'edit' && <BlogEditor />}
          {selectedTab === 'delete' && <BlogDeleter />}
          {selectedTab === 'translater' && <Transletar />}
        </div>
      </div>
    </div>
  );
};

export default ProductTab;